module.exports = __webpack_public_path__ + "img/AutomobileBackground_2.f579c6ad.png";